module.exports = __webpack_public_path__ + "img/-e-photo_06@2x.813074f8.png";